import { render, staticRenderFns } from "./TestStudioReviewsModal.vue?vue&type=template&id=91e17462"
import script from "./TestStudioReviewsModal.vue?vue&type=script&lang=js"
export * from "./TestStudioReviewsModal.vue?vue&type=script&lang=js"
import style0 from "./TestStudioReviewsModal.vue?vue&type=style&index=0&id=91e17462&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports